import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEOHead Component - Dynamic SEO meta tags for each page
 * NOTE: Title is NOT set here - inherited from index.html (Radio Solutions Apps)
 */
const SEOHead = ({ 
  title = 'Radio Solutions On Air',
  description = 'Καθημερινό περιεχόμενο για ραδιοφωνικές εκπομπές. Ζώδια, Charts, Ειδήσεις, Αθλητικά.',
  keywords = 'radio content, ραδιοφωνικό περιεχόμενο, apple music greece, youtube trending',
  image = '/api/og-banner/home',
  url = '',
  type = 'website'
}) => {
  // Use the production URL or the current window location
  const siteUrl = typeof window !== 'undefined' 
    ? window.location.origin 
    : 'https://radio-apps.online';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags - Title inherited from index.html */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:locale" content="el_GR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEOHead;
